// Configuración del molde del formulario
export const FORM_TEMPLATE = {
    generales: {
        title: "Información General",
        icon: "pi pi-info-circle",
        fields: {
        porton_tipo: { type: "dropdown", label: "Tipo de portón", options: [{label: "Corredera", value: "corredera"}, {label: "Basculante", value: "basculante"}, {label: "Seccional", value: "seccional"}] },
        porton_ancho_m: { type: "number", label: "Ancho portón (m)", placeholder: "ej: 3.5" },
        porton_alto_m: { type: "number", label: "Alto portón (m)", placeholder: "ej: 3.0" },
        electricidad_fase: { type: "dropdown", label: "Fase eléctrica", options: [{label: "Monofásico", value: "monofasico"}, {label: "Trifásico", value: "trifasico"}] },
        electricidad_amperaje: { type: "number", label: "Amperaje (A)", placeholder: "ej: 25" },
        ventilacion: { type: "dropdown", label: "Ventilación", options: [{label: "Natural", value: "natural"}, {label: "Forzada", value: "forzada"}, {label: "Mecánica", value: "mecanica"}] }
        }
    },
    caracteristicas: {
        title: "Características Físicas",
        icon: "pi pi-building",
        fields: {
        altura_m_hombro: { type: "number", label: "Altura al hombro (m)", placeholder: "ej: 4.5" },
        altura_maxima_m: { type: "number", label: "Altura máxima (m)", placeholder: "ej: 6" },
        piso: { type: "text", label: "Tipo de piso", placeholder: "ej: Hormigón H25 15 cm" },
        capacidad_carga_kg: { type: "number", label: "Capacidad de carga (kg)", placeholder: "ej: 5000" }
        }
    },
    servicios: {
        title: "Servicios e Instalaciones",
        icon: "pi pi-cog",
        fields: {
        baño: { type: "checkbox", label: "Baño" },
        oficina: { type: "checkbox", label: "Oficina" },
        estanterias: { type: "checkbox", label: "Estanterías incluidas" },
        montacargas: { type: "checkbox", label: "Montacargas disponible" }
        }
    },
    accesos: {
        title: "Accesos y Seguridad",
        icon: "pi pi-shield",
        fields: {
        acceso_camiones: { type: "checkbox", label: "Acceso para camiones" },
        rampa: { type: "checkbox", label: "Rampa de acceso" },
        camaras: { type: "checkbox", label: "Cámaras de seguridad" },
        cerco: { type: "checkbox", label: "Cerco perimetral" },
        guardiania: { type: "checkbox", label: "Guardianía" },
        alarma: { type: "checkbox", label: "Sistema de alarma" }
        },
    },

    observaciones: {
        title: "Observaciones",
        icon: "pi pi-comment",
        fields: {
        observaciones: { type: "textarea", label: "Observaciones generales", placeholder: "Información adicional..." }
        }
    }
};

// Moldes específicos por perfil
export const PROFILE_TEMPLATES = {
    frigorifica: {
        frio: {
        title: "Información Frigorífica",
        icon: "pi pi-snowflake",
        fields: {
            temp_min: { type: "number", label: "Temperatura mínima (°C)", placeholder: "ej: -25" },
            temp_max: { type: "number", label: "Temperatura máxima (°C)", placeholder: "ej: 5" },
            capacidad_frio_kW: { type: "number", label: "Capacidad frigorífica (kW)", placeholder: "ej: 50" },
            consumo_kWh: { type: "number", label: "Consumo energético (kWh)", placeholder: "ej: 100" },
            clasificacion_energetica: { type: "dropdown", label: "Clasificación energética", options: [{label: "A", value: "A"}, {label: "B", value: "B"}, {label: "C", value: "C"}] }
        }
        }
    },
    farmaceutica: {
        pharma: {
        title: "Información Farmacéutica",
        icon: "pi pi-heart",
        fields: {
            temp_min: { type: "number", label: "Temperatura mínima (°C)", placeholder: "ej: 15" },
            temp_max: { type: "number", label: "Temperatura máxima (°C)", placeholder: "ej: 25" },
            humedad_min: { type: "number", label: "Humedad mínima (%)", placeholder: "ej: 45" },
            humedad_max: { type: "number", label: "Humedad máxima (%)", placeholder: "ej: 55" },
            refrigeracion: { type: "checkbox", label: "Sistema de refrigeración" },
            humidificacion: { type: "checkbox", label: "Sistema de humidificación" },
            protocolos_limpieza: { type: "checkbox", label: "Protocolos de limpieza" },
            control_acceso: { type: "checkbox", label: "Control de acceso especializado" }
        }
        }
    },
    quimicos: {
        quimicos: {
        title: "Información para Químicos",
        icon: "pi pi-flask",
        fields: {
            renovaciones_aire: { type: "number", label: "Renovaciones de aire por hora", placeholder: "ej: 6" },
            estanterias_especificas: { type: "checkbox", label: "Estanterías específicas" },
            separacion_incompatibles: { type: "checkbox", label: "Separación de incompatibles" },
            contencion_derrame: { type: "checkbox", label: "Contención de derrames" },
            epp_disponible: { type: "checkbox", label: "EPP disponible" }
        }
        }
    },
    logistica_urbana: {
        logistica: {
        title: "Logística Urbana",
        icon: "pi pi-truck",
        fields: {
            ubicacion_estrategica: { type: "checkbox", label: "Ubicación estratégica" },
            andenes_carga: { type: "number", label: "Andenes de carga", placeholder: "ej: 4" },
            tiempos_carga: { type: "number", label: "Tiempos de carga/descarga (min)", placeholder: "ej: 15" },
            optimizacion: { type: "dropdown", label: "Optimización", options: [{label: "E-commerce < 24h", value: "ecommerce_24h"}, {label: "Distribución urbana", value: "distribucion_urbana"}] }
        }
        }
    }
};

export const PERFIL_OPTS = [
    { value: "estandar", label: "Estándar" },
    { value: "frigorifica", label: "Frigorífica" },
    { value: "quimicos", label: "Químicos" },
    { value: "farmaceutica", label: "Farmacéutica" },
    { value: "logistica_urbana", label: "Logística urbana" },
];


// Helpers compartidos (src/utilities/fichaTemplateHelpers.js)
export { toSnakeCase, getDefaultValue, generateInitialState } from "../../../utilities/fichaTemplateHelpers.js";
